import "./BuildBadge.css";

export function BuildBadge(): React.JSX.Element {
  return <div className="build-badge">{__BUILD_ID__}</div>;
}
